const MenuItemDivider = () => {
    return <span style={{marginLeft: "10px", borderLeft: "1px solid #ccc", paddingLeft: "10px"}}>&nbsp;</span>
}

export default MenuItemDivider